import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import BookingWidget from './BookingWidget';

/**
 * Hero Section Component
 */
const Hero = () => {
  const { t } = useLanguage();

  useEffect(() => {
    // Create animated circles overlay
    const createCircles = () => {
      const hero = document.getElementById('hero-section');
      if (!hero) return;

      const existing = hero.querySelector('.circles-overlay');
      if (existing) existing.remove();

      const circlesContainer = document.createElement('div');
      circlesContainer.className = 'circles-overlay';
      circlesContainer.style.cssText = 'position: absolute; inset: 0; overflow: hidden; pointer-events: none; z-index: 1;';
      
      for (let i = 0; i < 15; i++) {
        const circle = document.createElement('div');
        const size = Math.random() * 250 + 50;
        const delay = Math.random() * 5;
        const duration = Math.random() * 10 + 10;
        
        circle.style.cssText = `
          position: absolute;
          border-radius: 50%;
          border: 1px solid rgba(255,255,255,0.15);
          width: ${size}px;
          height: ${size}px;
          left: ${Math.random() * 100}%;
          top: ${Math.random() * 100}%;
          animation: circleFloat ${duration}s infinite ease-in-out;
          animation-delay: ${delay}s;
          opacity: ${Math.random() * 0.2 + 0.05};
          pointer-events: none;
        `;
        
        circlesContainer.appendChild(circle);
      }
      
      hero.insertBefore(circlesContainer, hero.firstChild);
    };

    createCircles();
  }, []);

  return (
    <section
      id="hero-section"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(26, 26, 46, 0.6), rgba(26, 26, 46, 0.7)), url('${process.env.PUBLIC_URL}/inc/images/bg.webp')`,
      }}
    >
      {/* Content */}
      <div className="relative z-10 text-center text-white px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 tracking-wide drop-shadow-lg">
          {t('home.heroTitle')}
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl mb-8 sm:mb-12 font-light tracking-wider drop-shadow-md">
          {t('home.heroSubtitle')}
        </p>
        
        {/* Custom Booking Widget */}
        <div className="max-w-4xl mx-auto">
          <BookingWidget variant="hero" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
